import styled from 'styled-components';
import { ModalDemoVehicleInfoStyled } from '../ModalDemoVehicleInfoStyled';
import { rem } from 'polished';

export const ModalDemoVehicleInfoStyledOV = styled(ModalDemoVehicleInfoStyled)`
    
`;
